module.exports = __webpack_public_path__ + "static/media/263.41c2ec1b.svg";